import { useSelector } from 'react-redux';
import { getTaskListSearch } from 'store/userInterface/userInterface.selectors';

export const useActiveSearch = () => {
  return useSelector(getTaskListSearch) !== null;
};
